import { render, staticRenderFns } from "./yqg-loan.vue?vue&type=template&id=0d6ceef9&scoped=true&"
import script from "./yqg-loan.js?vue&type=script&lang=js&"
export * from "./yqg-loan.js?vue&type=script&lang=js&"
import style0 from "./yqg-loan.scss?vue&type=style&index=0&id=0d6ceef9&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ceef9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d6ceef9')) {
      api.createRecord('0d6ceef9', component.options)
    } else {
      api.reload('0d6ceef9', component.options)
    }
    module.hot.accept("./yqg-loan.vue?vue&type=template&id=0d6ceef9&scoped=true&", function () {
      api.rerender('0d6ceef9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/kl-xiaodai/index/component/yqg-loan/yqg-loan.vue"
export default component.exports